<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="用户列表">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="isShowMore && 'show'">
                        <div class="search-condition">
                            <span class="label">用户</span>
                            <div class="input-condition">
                                <admin-auto-complete v-model="condition.id" factor-id="1" clearable></admin-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">角色</span>
                            <div class="input-condition">
                                <role-auto-complete v-model="condition.role_id" factor-id="1" clearable></role-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">是否启用</span>
                            <div class="input-condition">
                                <el-select v-model="condition.status">
                                    <el-option value="-1" label="全部" checked></el-option>
                                    <el-option value="0" label="启用"></el-option>
                                    <el-option value="1" label="禁用"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>

                    <a class="el-icon-d-arrow-left search-arrow-down" :class="!isShowMore && 'hide'" @click.stop="isShowMore = !isShowMore"></a>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                    </div>
                </div>
                <div class="clearfix" style="margin-bottom: 5px">
                    <el-button-group class="floatR">
                        <el-tooltip class="item" effect="dark" content="新增用户" placement="top">
                            <el-button icon="el-icon-plus" @click="handleAdd" v-permission="'user.admins.add'"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </div>
                <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        header-cell-class-name="table-back"
                >
                    <!--  -->
                    <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->
                    <el-table-column  label="ID" prop="id" width="80px"></el-table-column>
                    <el-table-column  label="用户名" prop="account" width="150px"></el-table-column>
                    <el-table-column  label="姓名" prop="name" width="150px"></el-table-column>
                    <el-table-column  label="角色" prop="role_name" width="180px"></el-table-column>
                    <el-table-column  label="权限站点" prop="site_counts"></el-table-column>
                    <el-table-column label="是否启用" prop="status">
                        <template slot-scope="scope">
                            <el-switch active-color="#13ce66" v-model="scope.row.status" active-value='0' inactive-value='1'  @change="status => change(status, scope.row)"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column  label="添加人" prop="creator_account" width="150px"></el-table-column>
                    <el-table-column  label="添加时间" prop="created_time" width="170px"></el-table-column>
                    <el-table-column  label="最后登录" prop="last_login_at" width="170px"></el-table-column>
                    <!-- 对于不需要绑定的列则不需要绑定props,如果自定义表头的话也可以不需要绑定label  -->
                    <el-table-column width="240px"  fixed="right">
                        <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                        <template slot="header" slot-scope="scope">
                            <span style="color: #409EFF">操作</span>
                        </template>
                        <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                        <template slot-scope="scope" v-if="scope.row.can_edit==true">
                                <el-button size="mini" @click="openEdit(scope.$index, scope.row)" v-if="scope.row.id!=1 && scope.row.status !=1" v-permission="'user.admins.edit'"
                                >编辑</el-button>
                                <el-button size="mini" v-if="scope.row.role_id != 2 && scope.row.role_id != 1" v-permission="'user.admins.set-sites'"
                                           @click="scope.row.status == 1 ? openSitesSet(scope.$index, scope.row,1) :  openSitesSet(scope.$index, scope.row,0)"
                                >授权站点</el-button>
                            <el-button type="danger" size="mini" @click="handleDelete(scope.$index, scope.row)" v-permission="'user.admins.delete'"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
                <template v-if="list.length > 0">
                    <!-- :total="list.length" -->
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"  :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>
                <add ref="add" :callback="initData" />
                <edit ref="edit" :callback="initData" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { getAdminList, getRoleList, modifyAdminStatus } from '@/service/user'
    import { parseTime } from '@/utils'
    import add from './userComponent/add'
    import edit from './userComponent/edit'
    import AdminAutoComplete from "../../../components/auto-complete/admin-auto-complete";
    import RoleAutoComplete from "../../../components/auto-complete/role-auto-complete";
    export default {
        name: "List",
        components: {
            RoleAutoComplete,
            AdminAutoComplete,
            add,
            edit,
        },
        data () {
            return {
                list: [],
                condition : {
                    id : '',
                    status : '',
                    role_id : '',
                    account : '',
                    page : 1,
                    total : 0,
                    per_page : 10,
                },
                roles : [
                    { id: '', name: '全部' }
                ],
                isLoading: false,
                isShowMore: false
            }
        },
        mounted () {
            this.initData()
        },
        methods: {
            openSitesSet(index, row,type) {
                let site_str = '';
                if (row.sites && row.sites[0] != '*')  {
                    let a = [];
                    for (var i in row.sites) {
                        a.push(i)
                    }
                    site_str = a.join('_');
                    this.$router.push('sites?id=' + row.id + '&site_str='
                        + site_str +'&type='+type)
                } else if (row.sites && row.sites[0] == '*') {
                    this.$router.push('sites?id=' + row.id + '&site_str=*&type='+type)
                } else {
                    this.$router.push('sites?id=' + row.id +'&type='+type)
                }
            },
            handleAdd(){
                const roleList = [...this.roles];
                roleList.splice(0, 1);
                this.$refs.add
                && (this.$refs.add.options = roleList)
                && this.$refs.add.open()
            },
            openEdit(index, row) {
                const roleList = [...this.roles];
                roleList.splice(0, 1);
                this.$refs.edit
                && (this.$refs.edit.options = roleList)
                && ( Object.assign(this.$refs.edit.userInfo, row))
                && this.$refs.edit.open()
            },
            handleSearch() {
                this.condition.page = 1;
                this.initData()
            },
            resetSearch() {
                this.condition = {
                    id : '',
                    status : '',
                    role_id : '',
                    page : 1,
                    total : 0,
                    per_page : 10,
                };
                this.initData()
            },
            /** 初始化数据请求 */
            async initData () {
                this.list = [];
                // 初始化之前设置当前页面的loading状态
                this.isLoading = true;
                // 模拟fetch请求数据....
                let query = {
                    status: this.condition.status,
                    page: this.condition.page,
                    per_page: this.condition.per_page
                };
                if (!!this.condition.id) {
                    query.id = this.condition.id
                }
                if (!!this.condition.role_id) {
                    query.role_id = this.condition.role_id
                }
                await getAdminList(query).then((data) => {
                    this.condition.total= parseInt(data.total);
                    this.condition.per_page = parseInt(data.per_page);
                    let listData = data.data;
                    for (let i in listData) {
                        let row = listData[i];
                        if (row.created_at)  {
                            row.created_time = parseTime(new Date(row.created_at))
                        } else {
                            row.created_time = ''
                        }
                        row.status = row.status.toString();
                        if (row.sites && row.sites[0] == '*') {
                            row.site_counts = '全部站点'
                        } else {
                            row.site_counts = row.sites ? this.attributeCount(row.sites) : 0
                        }
                    }
                    this.list = listData
                });
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            attributeCount (obj) {
                let count = 0;
                for(let i in obj) {
                    if(obj.hasOwnProperty(i)) {
                        count++;
                    }
                }
                return count;
            },
            currentChange (index) {
                this.condition.page = index;
                this.initData()
            },
            /** 监听到改变switch */
            change (status, data) {
                if (status == '1') {
                    this.$confirm('禁用后，该用户不能正常登录系统，是否确认？', '提示').then(_ => {
                        let query = {
                            status : status
                        };
                        modifyAdminStatus(data.id, query).then((data) => {
                            this.$message({
                                message: '修改成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                        }).catch(err => {
                            this.$message({
                                message: err.message || '修改失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                    }).catch(_ => {
                        data.status = status == '1' ? '0' : '1'
                    })
                } else {
                    this.$confirm('启用后，该用户可以正常登录系统，是否确认？', '提示').then(_ => {
                        let query = {
                            status : status
                        };
                        modifyAdminStatus(data.id, query).then((data) => {
                            this.$message({
                                message: '修改成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                        }).catch(err => {
                            this.$message({
                                message: err.message || '修改失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                    }).catch(_ => {
                        data.status = status == '1' ? '0' : '1'
                    })
                }
            },
            handleDelete(index, row) {
                this.$confirm('删除后，该用户将不可再登录系统，不可恢复，是否确认？', '提示').then(_ => {
                    let query = {
                        status : 2
                    };
                    modifyAdminStatus(row.id, query).then((data) => {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 3 * 1000
                        });
                        this.list.splice(index, 1)
                    }).catch(err => {
                        this.$message({
                            message: err.message || '删除失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                }).catch(_ => {
                })
            },
        }
    }
</script>

<style scoped>

</style>
